import CustomInput from "../../../elements/CustomInput/CustomInput";
import { useForm } from "react-hook-form";
import { Box, Button, Grid, Typography } from "@mui/material";
import _sendAPIRequest from "../../../helpers/api";
import { useContext, useState } from "react";
import { AlertContext } from "../../../contexts/AlertProvider";
import DeleteDialog from "../../../elements/CustomDialog/DeleteDialog";
import { AdminApiUrls } from "../../../helpers/api-urls/AdminApiUrls";

const BroadcastConfigForm = () => {
  const { control, handleSubmit, reset, watch, setError } = useForm({});
  const { setAlert } = useContext(AlertContext);
  const [confirm, setConfirm] = useState({
    title: "Broadcast Notifcation Confirmation",
    description: "Please confirm broadcasting notiications for the users",
    isconfirm: false,
    data: {},
  });

  const submitNotification = async (data) => {
    let formdata = new FormData();
    formdata = data;

    if (!data?.redirect_path) {
      formdata = { ...data, redirect_path: "/portal" };
    }

    try {
      const response = await _sendAPIRequest(
        "POST",
        AdminApiUrls?.BRODCASTING_NOTFICATION,
        formdata,
        true
      );
      if (response?.status === 200) {
        setAlert({
          isVisible: true,
          message: "Notification Broadcasted",
          severity: "success",
        });
      }
    } catch (error) {
      setAlert({
        isVisible: true,
        message: "Something went wrong",
        severity: "error",
      });
    } finally {
      reset();
    }
  };

  const handleBroadCastingConfirmation = (choice) => {
    if (choice) {
      handleSubmit(submitNotification)();
    }
    setConfirm({ ...confirm, isconfirm: false });
  };

  const handleBroadcastingSubmission = () => {
    const titleValue = watch("title");
    const detail = watch("body");
    if (!titleValue || !detail) {
      !titleValue &&
        setError("title", {
          type: "required",
          message: "Notification Title is required",
        });
      !detail &&
        setError("body", {
          type: "required",
          message: "Notification Details is required",
        });
      return;
    } else {
      setConfirm({ ...confirm, isconfirm: true });
    }
  };

  return (
    <>
      <Box
        sx={{
          maxWidth: 900,
          margin: "auto",
          p: 3,
          background: "#f9fcff",
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" sx={{
          fontWeight: "bold"
        }}>
          Create and Broadcast a Notification
        </Typography>

        <Typography variant="body2" sx={{ mb: 3 }}>
          Fill out the details below to send a notification to all users on
          Bidding Karo.
        </Typography>

        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Grid container spacing={2}>
            <Grid size={12}>
              <CustomInput
                control={control}
                name="title"
                label="Notification Title"
                inputType="text"
                placeholder="Enter your Notification title"
                rules={{ required: "Notification Title is required" }}
              />
            </Grid>

            <Grid size={12}>
              <CustomInput
                control={control}
                name="body"
                label="Notification Details"
                inputType="text"
                placeholder="Please Provide Notification Details"
                rules={{ required: "Notification Details is required" }}
                multiline={true}
              />
            </Grid>
            <Grid size={12}>
              <CustomInput
                control={control}
                name="redirect_path"
                label="Custom Link"
                inputType="text"
                placeholder="/portal"
                isRedirectPath={true}
              />
            </Grid>

            <Grid size={12} sx={{
              textAlign: "right"
            }}>
              <Button
                type="submit"
                variant="contained"
                className="btn button"
                onClick={handleBroadcastingSubmission}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
      {confirm?.isconfirm && (
        <DeleteDialog
          title={confirm?.title}
          message={confirm?.description}
          handleClick={handleBroadCastingConfirmation}
        />
      )}
    </>
  );
};

export default BroadcastConfigForm;
